export var NONE = 1;
export var INIT = 2;
export var PHONE_CONFIRMATION = 3;
export var EMAIL_SENT = 4;
export var SUCCESS = 5;



// WEBPACK FOOTER //
// ./src/constants/JoinStage.js